import { render, staticRenderFns } from "./DoctorMainView.vue?vue&type=template&id=65c0e9d7"
import script from "./DoctorMainView.vue?vue&type=script&lang=js"
export * from "./DoctorMainView.vue?vue&type=script&lang=js"
import style0 from "./DoctorMainView.vue?vue&type=style&index=0&id=65c0e9d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports